<template>
<div class="container">
    <div class="row">
        <div id="title" class="col-12 col-md-8">
            <h3>單月每日度數查詢</h3>
            <router-link :to="{ name: 'Main', params: { id: this.id }}">回首頁</router-link>
        </div>
        <div id="select" class="col-12 col-md-4">
            <h6>選取月份</h6>
            <vue-monthly-picker v-model="selectedMonth" dateFormat="YYYY-MM" @selected="changeMonth()"></vue-monthly-picker>
            <button class="btn btn-outline-dark" @click="addMonth(-1)">上個月</button>
            <button class="btn btn-outline-dark" @click="addMonth(1)">下個月</button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <flot-bar-chart :average='this.average' :ymax='this.flotMax' :xaxis='this.flotXAxis' :data='this.flotData' :averageData='this.flotAverageData' :tickSize='10'></flot-bar-chart>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';
import VueMonthlyPicker from "vue-monthly-picker";
import FlotBarChart from '@/components/FlotBarChart';

export default {
    name: 'BarMonth',
    components: {
        VueMonthlyPicker,
        FlotBarChart,
    },
    data() {
        return {
            id: '',
            selectedMonth: moment(),
            flotData: '',
            flotAverageData: '',
            flotXAxis: '',
            flotMax: '',
            average: ''
        }
    },
    created() {
        this.id = this.$route.params.id;
    },
    mounted() {
        this.getData();
    },
    methods: {
        addMonth: function (x) {
            var temp = moment(this.selectedMonth.add(x, 'M'));
            this.selectedMonth = temp;
            this.getData();
        },
        changeMonth: function () {
            this.getData();
        },
        getData: function () {
            var year = this.selectedMonth.year();
            var month = this.selectedMonth.month() + 1;
            var api_url = process.env.VUE_APP_SOALR_URL + `/api/solar/daily/${this.id}/${year}/${month}`;
            let self = this;

            this.$http
                .get(api_url)
                .then(res => {
                    const data = res.data;

                    self.flotData = data.data;
                    self.flotAverageData = data.average.avgArray;
                    self.flotXAxis = data.xAxis;
                    self.flotMax = Math.ceil(data.totalWatt * 7);
                    self.average = data.average.average;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/bar.scss";
</style>
